<template>
  <div class="contaier">
    <head-page />

    <div class="banner-box">
      <swiper ref="bannerSwiper" class="banner-swiper" :options="bannerOptions" @slideChangeTransitionEnd="onBannerSlideChange">
        <swiper-slide :key="index" v-for="(item, index) in bannerList">
          <picture>
            <source
              alt=""
              media="(max-width: 760px)"
              :srcset="item.imgKV_mobile"
            />
            <img class="img" alt="" :srcset="item.imgKV" />
          </picture>
          <!-- <div class="text-box">
            <div class="title hq-title1" v-html="item.title"></div>
          </div> -->
        </swiper-slide>
      </swiper>
      <CenterIndicator
        class="banner-indicator"
        :currentIndex="bannerIndex"
        :totalCount="bannerList.length"
      ></CenterIndicator>
    </div>

    <!-- 转轮进入 -->
    <CarShowcase :carShowList="carShowList" />
    <!-- ---------------------------- 车 ---------------------------- -->
    <!-- <div class="explorers-hongqi">
      <div class="hq-title1">{{ $t('public.exploreH') }}</div>
      <div class="t-car">
        <div
          class="t-car_item"
          @click="clickCar(index)"
          v-for="(item, index) in modelList"
          :key="item.id">
          <div class="car-name" :class="{ 'car-name_ac': carIndex === index }">
            {{ item.modelName }}
          </div>
        </div>
      </div>

      <div class="explorers-bg">
        <div class="car-box_out">
          <div :key="item.id" v-for="(item, index) in modelList">
            <div
              :key="item.id"
              class="title-box"
              :class="{ 'title-box_curr': carIndex === index }">
              <div class="hq-t_b">{{ item.modelName }}</div>
              <div class="btn" @click="goNewPage2('/carDetails', item.id)">
                探索
              </div>
              <template v-for="(item2, index2) in item.exterior">
                <div
                  class="color-name"
                  :key="item2.id"
                  v-if="carIndex2 === index2">
                  {{ item2.color }}
                </div>
              </template>
            </div>
          </div>

          <div
            class="car-box"
            :key="`car${item.id}`"
            v-for="(item, index) in modelList"
            :class="{ 'car-box_curr img-box_error': carIndex === index }">
            <div
              :key="item2.id"
              class="car-img_box"
              v-for="(item2, index2) in item.exterior">
              <img
                class="car-img"
                :class="{ 'car-img_ac': carIndex2 === index2 }"
                :src="item2.front_45_side" />
            </div>
          </div>
        </div>

        <template v-for="(item, index) in modelList">
          <div :key="item.id" class="car-select max-box">
            <template v-if="carIndex === index">
              <div
                class="car car1"
                :key="item2.id"
                v-for="(item2, index2) in item.exterior"
                :class="[
                  item2.front_color,
                  carIndex2 === index2 ? 'car-ac' : '',
                ]"
                @click="clickColorCar2(index2)">
              </div>
            </template>
          </div>
        </template>
      </div>
    </div> -->

    <!-- ----------------------------------------------- -->
    <!-- <div class="home-page2">
      <div
        class="image-container flex w-full h-[100vh] h-[auto] lg:h-[100vh] p-0 flex-col lg:flex-row"
      >
        <div
          class="image-item w-full lg:w-1/2 lg:overflow-hidden overflow-initial bg-[#000] opacity-100 translate-y-0"
        >
          <div
            @mouseenter="playVideo(1)"
            @mouseleave="pauseVideo(1)"
            class="image-wrapper lg:h-full h-[5.42rem]"
          >
            <video
              loop
              muted
              playsinline
              preload="auto"
              class="bg-video"
              ref="videoPlayer1"
              src="https://cms-prod-obs.icaurglobal.com/platform/public/icar_global/material/video/v23.mp4"
            ></video
            ><img
              class="bg-image"
              src="https://www.icaurglobal.com/global/images/home/page2-1.webp"
              alt="Image 1"
            />
            <div class="icon-wrapper w-full flex flex-col items-center h-full">
              <img
                alt="Icon 1"
                class="icon"
                src="https://www.icaurglobal.com/global/images/home/page2-1-icon.webp"
              />
              <div
                @click="goNewPage2('/carDetails', 1)"
                class="explore-button flex items-center justify-center w-full h-full mt-[0.27rem] lg:mt-[0.24rem] h-[0.3rem] lg:h-[0.28rem] leading-[0.3rem] lg:leading-[0.28rem]"
              >
                <p class="text-[#C19459] font-GothamMedium font-[500]">
                  EXPLORE MORE
                  <img
                    alt=""
                    class="select-none inline-block object-cover"
                    src="https://www.icaurglobal.com/global/images/common/right_arrow_coffee.webp"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="image-item w-full lg:w-1/2 lg:overflow-hidden overflow-initial bg-[#000] opacity-100 translate-y-0"
        >
          <div
            @mouseenter="playVideo(3)"
            @mouseleave="pauseVideo(3)"
            class="image-wrapper lg:h-full h-[5.42rem]"
          >
            <video
              loop
              muted
              playsinline
              preload="auto"
              class="bg-video"
              ref="videoPlayer3"
              src="https://cms-prod-obs.icaurglobal.com/platform/public/icar_global/material/video/iChery20260120-155722.mp4"
            ></video>

            <img
              class="bg-image"
              src="https://www.icaurglobal.com/global/images/home/page2-2.webp"
              alt="Image 3"
            />

            <div class="icon-wrapper w-full flex flex-col items-center h-full">
              <img
                src="https://www.icaurglobal.com/global/images/home/page2-2-icon.webp"
                alt="Icon 3"
                class="icon"
              />

              <div
                @click="goNewPage2('/carDetails', 2)"
                class="explore-button flex items-center justify-center w-full h-full mt-[0.27rem] lg:mt-[0.24rem] h-[0.3rem] lg:h-[0.28rem] leading-[0.3rem] lg:leading-[0.28rem]"
              >
                <p class="text-[#C19459] font-GothamMedium font-[500]">
                  EXPLORE MORE
                  <img
                    alt=""
                    class="select-none inline-block object-cover"
                    src="https://www.icaurglobal.com/global/images/common/right_arrow_coffee.webp"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- ---------------------------- 新闻 ---------------------------- -->
    <div class="events-hq">
      <div class="events-box">
        <div class="hq-title1">最新消息</div>
        <div class="box">
          <div :key="item.id" class="about-item" v-for="item in newsList" @click="goNewPage2('/news/details', item.id)">
            <div class="img-box" >
              <img class="car-img" :src="item.img" alt="" />
            </div>
            <div class="text">{{ item.title }}</div>
            <div class="b-box">
              <div class="date">{{ item.createTime }}</div>
            </div>
          </div>
        </div>
        <div class="more-news" @click="clickToMore">了解更多</div>
      </div>
    </div>
    <footer-page></footer-page>
  </div>
</template>

<script>
import { throttle } from "lodash";
import { activityTime } from "@/utils/utils";
// import { langMixins } from '@/mixins/langMixins'
import { modelListApi, newsListApi } from "@/Api/requestApi";
import HeadPage from "@/components/HeadPage.vue";
import CarShowcase from "@/components/CarShowcase.vue";
import CenterIndicator from "@/components/CenterIndicator.vue";
import FooterPage from "@/components/FooterPage.vue";
import {
  // carList,
  imgBase,
  imgBase2,
  aboutList,
  // homeSwiper,
} from "@/assets/js/static";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "HomeView",
  // mixins: [langMixins],
  components: {
    HeadPage,
    CarShowcase,
    CenterIndicator,
    FooterPage,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      // topBanner: {},
      bannerList: [],
      bannerIndex: 0,
      bannerOptions: {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 800,
        autoplay: false,
      },
      carShowList: [],
      // modelList: carList,
      aboutList,
      // imageUrl: require("@/assets/img/list/7.jpg"),
      // imgsrc,
      // carouselList,
      // textList,
      // homeSwiper
      speak: "中文",
      carIndex: 0,
      carIndex2: 0,
      paramH: "810px",
      // windowWidth:1680
      // modelList: [],
      homeModelList: [],
      mainSwiper: null,
      scrollHandler: null,
      // mainOptions: {
      //   loop: false,
      //   slidesPerView: 1,
      //   spaceBetween: 0,
      //   effect: "slide",
      //   speed: 300,
      //   uniqueNavElements: false,
      //   autoplay: false, // 禁止自动轮播
      // },
      mainI: 0,
      newsList: [],
    };
  },
  mounted() {
    this.mainSwiper = this.$refs.swiperMain?.$swiper;
    this.modelListFn();
    this.getNewsListFn();
    this.$nextTick(() => {
      this.scrollHandler = throttle(this.handleResize, 200);
      window.addEventListener("resize", this.scrollHandler);
      this.handleResize();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      // console.log('22222 :>> ', 22222)
      // 获取 Swiper 实例
      // this.langFn()
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.scrollHandler);
  },
  methods: {
    onBannerSlideChange() {
      const swiper = this.$refs.bannerSwiper.$swiper;
      this.bannerIndex = swiper.realIndex;
    },
    handleResize() {
      let ww_ = window.innerWidth;
      // console.log('ww_ :>> ', ww_);
      if (ww_ < 668) {
        // this.paramH = '760px'
        // this.paramH = '460px'
      } else if (ww_ < 768) {
        // this.paramH = '760px'
        // this.paramH = '500px'
      } else if (ww_ < 992) {
        // this.paramH = '660px'
      } else {
        // this.paramH = '810px'
      }
      // this.currentIndex = 0
      // this.windowWidth = ww_
    },
    async modelListFn() {
      const {
        data: { code, data },
      } = await modelListApi({ state: 1 });
      if (code == 200) {
        let list_ = [];
        let homeList_ = [];
        console.log("data :>> ", data);
        let carShowList_ = [];
        // this.topBanner = {
        //   imgKV: `${imgBase}/icaur_kv1.jpg`,
        //   imgKV_mobile: `${imgBase}/icaur_kv2.jpg`
        // }
        this.bannerList = [
          {
            imgKV: `${imgBase2}icaur_kv4-2.jpg`,
            imgKV_mobile: `${imgBase2}icaur_kv4_move.jpg`,
            title: '錦龍汽車集團旗下獨家代理的 <br/> iCAUR 香港旗艦陳列室於九龍灣',
          },
          {
            imgKV: `${imgBase2}icaur_kv3.jpg`,
            imgKV_mobile: `${imgBase2}icaur_kv3_move.jpg`,
            title: '',
          },
        ];
        for (let i = 0; i < data.length; i++) {
          // let exterior_ = [];
          //  exterior,
          const { id,  modelName, model_car } = data[i];
          // imgKV, imgKV_mobile,
          // if (modelName == "V27") {
          //   this.topBanner = {
          //     imgKV: `${imgBase}${imgKV}`,
          //     imgKV_mobile: `${imgBase}${imgKV_mobile}`,
          //   };
          // }
          // let { car_model = "", car_modelEn = "" } = JSON.parse(model_style)[0];
          let { highImg, modeLogo, frontImg } = JSON.parse(model_car)[0];

          carShowList_.push({
            id,
            modelName,
            highImg: `${imgBase}${highImg}`,
            modeLogo: `${imgBase}${modeLogo}`,
            frontImg: `${imgBase}${frontImg}`,
          });

          // console.log("JSON.parse(model_car) :>> ", JSON.parse(model_car));
          // let side_90 = ''
          // for (let j = 0; j < exterior.length; j++) {
          //   const { front_45_side, front_90_side, front_color } = exterior[j]
          //   if (j === 0) {
          //     side_90 = `${imgBase}${front_90_side}?iopcmd=thumbnail&type=4&width=400&quality=60`
          //   }
          // exterior_.push({
          //   id: j + 1,
          //   front_45_side: `${imgBase}${front_45_side}?iopcmd=thumbnail&type=4&width=700&quality=60`,
          //   front_45_sideArr: [`${imgBase}${front_45_side}`],
          //   front_90_side: `${imgBase}${front_90_side}`,
          //   front_color: `${imgBase}${front_color}`,
          // })
          // }
          // list_.push({
          //   id,
          //   side_90,
          //   modelName,
          //   to: '/carDetails',
          //   exterior: exterior_,
          // })

          homeList_.push({
            id,
            modelName,
          });
        }

        console.log("list_ :>> 222", list_);
        console.log("homeList_ :>> ", homeList_);

        this.modelList = list_;
        this.carShowList = carShowList_;
        this.homeModelList = homeList_;
      }
    },
    clickCar(i) {
      // this.carIndex2 = -1;
      // this.$nextTick(() => {
      this.carIndex2 = 0;
      this.carIndex = i;
      // });
    },
    clickColorCar2(i) {
      // this.carIndex = 0;
      this.carIndex2 = i;
    },
    goNewPage2(p, id) {
      let id_ = "";
      if (id) {
        id_ = id;
      } else {
        id_ = this.carShowList[this.carIndex2].id;
      }
      this.$router.push({ path: p, query: { id: id_ } }).catch(() => {});
    },

    async getNewsListFn() {
      const {
        data: { code, data },
      } = await newsListApi({ state: 1, page: 1, pageSize: 3 });
      if (code == 200) {
        let newsList_ = [];
        for (let i = 0; i < data.length; i++) {
          let { id, title, titleImage, createTime } = data[i];
          newsList_.push({
            id,
            title: title,
            createTime: activityTime(createTime),
            img: `${imgBase}${titleImage}`,
            // img: `${imgBase}${titleImage}?iopcmd=thumbnail&type=4&width=600&quality=60`,
          });
        }

        this.newsList = newsList_;
        // console.log("newsList_ :>> ", newsList_);
      }
    },
    clickToMore() {
      this.$router
        .push({ path: "/news", query: { lang: this.$i18n.locale } })
        .catch(() => {});
    },
    playVideo(i) {
      this.$refs[`videoPlayer${i}`].play();
    },
    pauseVideo(i) {
      this.$refs[`videoPlayer${i}`].pause();
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
// @import 'element-ui/lib/theme-chalk/display.css';

.el-carousel__item {
  margin: 0;
}

.img {
  object-fit: cover;
}
.contaier {
  .banner-box {
    height: 100vh;
    position: relative;
    color: #fff;
    overflow: hidden;
    .banner-swiper {
      width: 100%;
      height: 100%;
    }
    .banner-swiper ::v-deep .swiper-wrapper,
    .banner-swiper ::v-deep .swiper-slide {
      width: 100%;
      height: 100%;
    }
    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .title {
      font-size: 36px;
      display: flex;
      text-align: left;
      
    }
    
    .text-box {
      position: absolute;
      left: 8%;
      top: 40%;
      transform: translateY(-80%);
      z-index: 2;
    }
    .banner-indicator {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
      ::v-deep .page-text {
        display: none;
      }
    }
  }
  // --------------------------------------------------
  .home-page2 {
    margin-top: 80px;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 100vh;
    padding: 0;
    .image-container {
      // display: flex;
      // align-items: center;
    }
    .bg-image {
      height: 100%;
      left: 0;
      -o-object-fit: cover;
      object-fit: cover;
      position: absolute;
      top: 0;
      transition: all 0.3s ease;
      width: 100%;
    }

    .image-item:hover {
      .bg-image {
        // display: none;
        opacity: 0;
        transform: scale3d(1.05, 1.05, 1.05);
      }
    }

    .image-item,
    .image-wrapper {
      cursor: pointer;
      position: relative;
      transform-origin: center;
    }

    .image-wrapper {
      width: 100%;
      height: 100%;
      overflow: hidden;
      background: #f0f0f0;
      .explore-button {
        padding-top: 20px;

        .font-GothamMedium {
          font-size: 14px;
        }
        .select-none {
          width: 18px;
          transition: width 0.3s ease;
        }
        .font-GothamMedium:hover {
          // font-size: 14px;
          .select-none {
            width: 25px;
          }
        }
      }
    }

    .bg-video {
      height: 100%;
      left: 0;
      -o-object-fit: cover;
      object-fit: cover;
      position: absolute;
      top: 0;
      transition: opacity 0.3s ease;
      width: 100%;
    }
    .video-visible {
      opacity: 1;
      pointer-events: auto;
    }
    .icon-wrapper {
      align-items: center;
      display: flex;
      justify-content: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
      .icon {
        height: 24px;
        -o-object-fit: contain;
        object-fit: contain;
        width: auto;
      }
    }
  }

  // ------------------------ 红旗活动**start ------------------------
  .events-hq {
    padding: 80px 0;
    .events-box {
      max-width: 1770px;
      margin: 0 auto;
      .hq-title1 {
        font-size: 32px;
        font-weight: 600;
      }
      .box {
        padding: 80px 20px 0;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        min-height: 320px;
        .about-item {
          overflow: hidden;
          width: calc((100% - 60px) / 3);
          margin-bottom: 40px;
          // position: relative;
          // padding-top: 160%;
          .img-box {
            // position: absolute;
            // top: 0;
            // left: 0;
            aspect-ratio: 16 / 10;
            overflow: hidden;
            background-color: #fafafa;
          }
          .car-img {
            width: 100%;
            transition: all 0.6s;
            aspect-ratio: 16 / 10;
            overflow: hidden;
            cursor: pointer;
          }
          .car-img:hover {
            transform: scale3d(1.05, 1.05, 1.05);
          }

          .text {
            height: 70px;
            margin-top: 10px;
            font-weight: 700;
            // border-bottom: solid 1px #222;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            font-size: 24px;
            cursor: pointer;
            color: #333;
          }
          .b-box {
            padding-top: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .date {
              font-size: 14px;
              color: #999;
            }
            .btn {
              width: 100px;
              line-height: 32px;
              font-size: 12px;
              text-align: center;
              border: solid 2px #333;
              cursor: pointer;
              // z-index: 9999;
              color: #333;
            }
            .btn:hover {
              background-color: rgba(255, 255, 255, 1);
              color: #222;
            }
          }
        }
        .about-item:nth-child(n + 2) {
          margin-left: 30px;
        }
        .about-item:nth-child(3n + 1) {
          margin-left: 0;
        }
        // .about-item:hover {
        //   .car-img {
        //     transform: scale3d(1.1, 1.1, 1.1);
        //   }
        // }
      }
    }
  }
  // ------------------------ 车**start ------------------------
  .explorers-hongqi {
    padding-top: 60px;
    padding-bottom: 60px;
    .hq-title1 {
      padding-bottom: 20px;
    }
    .t-car {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 40px;
      cursor: pointer;
      .t-car_item {
        // flex: 1;
        // max-width: 300px;
        margin: 0 20px;
        text-align: center;
        .img-box {
          aspect-ratio: 16 / 8;
        }
        .car-name {
          width: 100px;
          height: 60px;
          margin: 0 auto;
          // padding-bottom: 1.4vw;
          padding-bottom: 10px;
          border-bottom: solid 2px #fff;
        }
        .car-name_ac {
          font-weight: 600;
          border-bottom: solid 2px #222;
        }
      }
    }
    .explorers-bg {
      height: 450px;
      background-color: #fafafa;
      // background-image: url('@/assets/img/cartype_bg.jpg');
      // background-position: bottom center;
      // background-repeat: no-repeat;
      // background-size: 100% 100%;
      position: relative;
      .car-box_out {
        position: relative;
        height: 100%;
        overflow: hidden;
        .car-box {
          width: 100%;
          max-width: 650px;
          aspect-ratio: 13 / 5.2;
          position: absolute;
          top: 50%;
          right: -100%;
          transform: translate(50%, -50%);
          transition: right 0.6s;
          opacity: 0;
        }

        .car-box_curr {
          // top: 50%;
          right: 40%;
          opacity: 1;
          .car-img_box {
            position: relative;
            .car-img {
              width: 100%;
              aspect-ratio: 16 / 6.8;
              object-fit: cover;
              position: absolute;
              top: 0;
              left: 0;
              opacity: 0;
              transition: opacity 0.6s ease;
              // background-color: #fafafa;
            }
            .car-img_ac {
              opacity: 1;
            }
          }
        }
      }
      .car-select {
        position: absolute;
        bottom: 20px;
        // left: 200px;
        left: 20%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .car {
          width: 50px;
          height: 50px;
          margin-right: 15px;
          border-radius: 5px;
          overflow: hidden;
          border: solid 3px rgba(255, 255, 255, 0);
          cursor: pointer;
          .car-color {
            width: 100%;
            height: 100%;
          }
        }
        .car:hover {
          border: solid 3px #fff;
        }
        .car-ac {
          border: solid 3px #fff;
        }
      }
      .title-box {
        width: 300px;
        position: absolute;
        top: 10%;
        left: -80%;
        transform: translate(50%, 0%);
        z-index: 99;
        .color-name {
          padding-top: 80px;
          font-size: 32px;
          // line-height: 60px;
          // text-align: center;
        }
        .hq-t_b {
          font-size: 46px;
          margin-bottom: 10px;
        }
        .btn {
          width: 200px;
          margin: 0 auto;
          font-size: 16px;
          line-height: 56px;
          font-family: "IcaurFontMedium";
          cursor: pointer;
          text-align: center;
          color: #fff;
          background-color: #333;
        }
      }
      .title-box_curr {
        top: 10%;
        left: 20%;
        transform: translate(0%, 0%);
        transition: all 0.6s;
      }
    }
  }
}
// .el-divider__text {
//   cursor: pointer;
// }

// @media (max-width: 992px) {
//     .events-hq {
//     .events-box {
//       .box {
//         .about-item {
//           width: calc((100% - 30px) / 2);
//         }
//       }
//     }
//   }
// }
@media (max-width: 768px) {
  .contaier {
    .banner-box {
      .text-box {
        position: absolute;
        left: 4%;
        top: 30%;
        transform: translateY(-60%);
      }
      .title {
        font-size: 30px;
      }
    }
  }
}

@media (max-width: 468px) {
  .contaier {
    .banner-box {
      .text-box {
        position: absolute;
        left: 3%;
        top: 35%;
        transform: translateY(-65%);
      }
      .title {
        font-size: 24px;
      }
    }
  }
}
.more-news {
  position: relative;
  width: 180px;
  margin: 30px auto 0;
  line-height: 46px;
  font-size: 18px;
  text-align: center;
  font-weight: 600;
  border-radius: 5px;
  border: #222 solid 1px;
  cursor: pointer;
  z-index: 1;
}

.more-news::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  transform: scaleX(0);
  transform-origin: left;
  transition: all 0.35s ease;
  z-index: -1;
}

.more-news:hover {
  transform: scaleX(1);
  color: #fff;
}

.more-news:hover::before {
  transform: scaleX(1);
}

@import "./css/HomeView-media";

.color-orange {
  background: linear-gradient(180deg, #da5301, #edaa81);
}
.color-silver {
  background: linear-gradient(180deg, #b4b7bf, #d8dade);
}
.color-green {
  background: linear-gradient(180deg, #4e523b, #a6a89d);
}
.color-white {
  background: linear-gradient(180deg, #f4f4f4, #f9f9f9);
}
.color-black {
  background: linear-gradient(180deg, #1c1c1c, #878787);
}
.color-purple {
  background: linear-gradient(180deg, #663e5f, #bfa8bb);
}
.color-blue {
  background: linear-gradient(180deg, #41729d, #c3daef);
}
.color-gray {
  background: linear-gradient(180deg, #666, #999);
}
.color-yellow {
  background: linear-gradient(180deg, #dba31a, #eac875);
}
</style>
